import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const query = async (userId: string) => {
  const { data, error, count } = await supabase
    .from('products_favorite')
    .select(`*, products(*)`, { count: 'exact' })
    .eq('user', userId);

  if (error) {
    throw new Error(error.message);
  }

  return { data, count };
};

export const useGetFavoriteProducts = (userId: string) => {
  return useQuery(['useGetFavoriteProducts', userId], () => query(userId), {
    enabled: !!userId,
  });
};
